/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import CreateTest from "../../components/ModalComponents/CreateTest";
import TEST_LIBRARY_ICON_CRONOLOGY from "../../assets/image/TEST_LIBRARY_ICON_CRONO.svg";
import TEST_LIBRARY_ICON_POPULAR from "../../assets/image/TEST_LIBRARY_ICON_POPULAR.svg";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { allCreatedTest, reset } from "../../features/Test/testSlice";
import swal from "sweetalert";
import { Wave } from "../../components/TableOptions";

const Test = () => {
	const dispatch = useAppDispatch();
	const { allCreatedTestdata, allCreatedTestisError, allCreatedTestmessage, allCreatedTestisLoading } = useAppSelector((state: { test: any; }) => state.test)
	const { isSuccess } = useAppSelector((state: { test: any; }) => state.test)



	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		dispatch(allCreatedTest());

	}, [dispatch, isSuccess])



	useEffect(() => {
		if (allCreatedTestisError) {
			swal({
				title: "error",
				text: allCreatedTestmessage,
				icon: "error"
			})
			dispatch(reset())
		}

	}, [allCreatedTestisError, allCreatedTestmessage, dispatch])



	return (
		<div id='screen-wrappers'>
			<TopNavigation />
			<div className="app_body">
				<div className="test-container-content">
					<div className="mt-header title-50-poppins">
						<h1>Measure your candidates<br />on job skills, personality and fit</h1>
					</div>
					<div className="test-search-container">
						<input className="search__input" type="text" placeholder="Search" />
						<div className="newtest-button">
							<Button className="view-HIRED-profile" onClick={handleShow}>
								Create Test
							</Button>
						</div>
					</div>
					<div className="results-test">
						{allCreatedTestisLoading ? <Wave /> : allCreatedTestdata?.data?.map((item: any, index: any) => (
							<div className="mat-card-wrapper" key={index}>
								<div className="mat-card">
									<div className="mat-card-featured popular">
										<img className="lazy-loaded" src={TEST_LIBRARY_ICON_POPULAR} data-lazy-type="image" alt="Popular" />
										<span>Popular</span>
									</div>
									<div className="mat-card-content">
										<div className="mat-card-header">
											<span className="mat-card-title">{item?.testTitle}</span>
										</div>
										<div className="mat-card-text">{item?.testDescription}</div>
									</div>
									<div className="mat-card-actions">
										<div className="test-card__duration">
											<img className="no-lazy" src={TEST_LIBRARY_ICON_CRONOLOGY} alt="Clock" />
											<span>{item?.totalScore} min</span>
										</div>
										<div className="mat-card-buttons"  >
											<Link to={`/testdetails/${item?.id}`}>
												<a href="#" className="mat-button-base tg-button">Details</a>
											</Link>
										</div>
									</div>
								</div>
							</div>
						))}

					</div>
				</div>
			</div>
			<CreateTest show={show} setShow={setShow} />
		</div>
	);
}

export default Test
